import classNames from 'classnames';

import { FormFieldWrap } from '@zooplus/ui-components';

import FormMessages from '../FormMessages/FormMessages';

import styles from './FormControlWrapper.module.scss';

export type FormControlWrapperProps = {
  label?: string;
  labelFor?: string;
  infoMessageIcon?: React.ReactElement;
  infoMessage?: React.ReactNode;
  errorZta?: string;
  /* The error message to show for this input field. */
  errorMessage?: React.ReactNode;
  /* Set inline label for the field. */
  labelInline?: boolean;
  /* Controls whether the input info message should be visible */
  hasInfoMessage?: boolean;
  /* Controls whether the input label should be visible */
  hasLabel?: boolean;
  /* Displays an icon on the right side of the input */
};

const FormControlWrapper: React.FC<FormControlWrapperProps> = ({
  children,
  labelInline = false,
  label,
  labelFor,
  infoMessageIcon,
  infoMessage,
  errorMessage,
  errorZta,
}) => {
  return (
    <FormFieldWrap
      className={classNames(styles.formControlWrapper, {
        [styles.noLabelInput]: !label,
      })}
      columnWidths={labelInline ? ['15rem', 'calc(100% - 15rem)'] : undefined}
      labelText={label}
      labelFor={labelFor}>
      <div className={classNames({ [styles.spacer]: !label })}></div>
      <div>
        {children}
        <FormMessages
          infoMessage={infoMessage}
          errorMessage={errorMessage}
          infoMessageIcon={infoMessageIcon}
          errorZta={errorZta}
          labelFor={labelFor}
        />
      </div>
    </FormFieldWrap>
  );
};

export default FormControlWrapper;
